// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__35wN0","plus":"Card_plus__3MF9E","favorite":"Card_favorite__-ptFE"};